{/*
import React from "react";
import { Box, Typography, Button, CssBaseline } from "@mui/material";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

class Contact extends React.Component {
  render() {
    return (
      <>
        <CssBaseline />

        <Box
          sx={{
            minHeight: "100vh",
            width: "100%",
            bgcolor: "#1A1A1A",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            flexDirection: "column",
            py: 8,
            px: 3
          }}
        >

     
          <Box
            sx={{
              width: "100%",
              maxWidth: "500px",
              display: "flex",
              flexDirection: "column"
            }}
          >

   
            <Button
              onClick={() => window.location.href = "/"}
              sx={{
                color: "#FFFDF8",
                mb: 3,
                minWidth: 0,
                px: 0,
                alignSelf: "flex-start"
              }}
            >
              <ArrowBackIcon />
            </Button>

        
            <Box
              component="img"
              src="/Colloquia_Logo.png"
              alt="Company Logo"
              sx={{
                width: 140,
                borderRadius: "12px",
                mb: 4,
                alignSelf: "flex-start"
              }}
            />

         
            <Typography
              sx={{
                color: "#FFFDF8",
                mb: 5,
                fontSize: "2rem",
                fontWeight: 300,
                textAlign: "center"
              }}
            >
              Contact
            </Typography>

 
            <Box
              sx={{
                bgcolor: "#262626",
                border: "1px solid #555",
                borderRadius: "12px",
                p: 4
              }}
            >

              <Typography
                sx={{
                  color: "#FFFDF8",
                  fontSize: "1.15rem",
                  lineHeight: 1.8,
                  textAlign: "center",
                  mt: 2
                }}
              >
                Email: princevc@colloquia-us.com
              </Typography>

              <Typography
                sx={{
                  color: "#FFFDF8",
                  fontSize: "1.15rem",
                  lineHeight: 1.8,
                  textAlign: "center",
                  mt: 2
                }}
              >
                Twitter/X: @Prince__VC
              </Typography>

            </Box>

          </Box>

        </Box>
      </>
    );
  }
}

export default Contact;
*/}
import React from "react";
import {
  Box,
  Typography,
  Button,
  CssBaseline
} from "@mui/material";
import { useHistory } from "react-router-dom";

const CONTACT_WHITE = "#FFFDF8";
const CONTACT_GRAY = "#B8B8B8";
const CONTACT_MUTED = "#777777";

/*
 * ============================================================
 * COLLOQUIA CONTACT INFORMATION
 * ============================================================
 *
 * Replace these three values with your actual company contact
 * information.
 *
 * Examples:
 *
 * EMAIL:
 *   support@colloquia-us.com
 *
 * X / TWITTER:
 *   https://x.com/YourCompany
 *
 * LINKEDIN:
 *   https://www.linkedin.com/company/YourCompany
 *
 * If you don't want one of the social links displayed yet,
 * set its value to an empty string: ""
 */

const CONTACT_EMAIL = "princevc@colloquia-us.com";

const CONTACT_X = "https://x.com/Prince__VC";

const CONTACT_LINKEDIN =
  "https://www.linkedin.com/company/colloquia-us";


function ContactPage() {
  const history = useHistory();

  const sectionTitleSx = {
    fontSize: {
      xs: "1.35rem",
      md: "1.6rem"
    },
    fontWeight: 400,
    letterSpacing: "-0.01em",
    color: CONTACT_WHITE,
    mb: 2
  };

  const bodySx = {
    fontSize: {
      xs: "0.95rem",
      md: "1rem"
    },
    lineHeight: 1.8,
    fontWeight: 300,
    color: CONTACT_GRAY,
    mb: 2.5
  };

  const contactCardSx = {
    border: "1px solid #292929",
    borderRadius: "14px",
    p: {
      xs: 3,
      md: 4
    },
    bgcolor: "#080808",
    transition:
      "border-color 180ms ease, transform 180ms ease",

    "&:hover": {
      borderColor: "#444",
      transform: "translateY(-2px)"
    }
  };

  return (
    <>
      <CssBaseline />

      <Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#000",
          color: CONTACT_WHITE
        }}
      >
        {/* =====================================================
            HEADER
            ===================================================== */}

        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 10,

            bgcolor: "rgba(0, 0, 0, 0.94)",
            backdropFilter: "blur(12px)",

            borderBottom: "1px solid #222",

            px: {
              xs: 3,
              md: 6
            },

            py: 2.5,

            display: "flex",
            alignItems: "center",
            justifyContent: "space-between"
          }}
        >
          {/* Logo */}

          <Box
            component="button"
            type="button"
            onClick={() => history.push("/")}
            aria-label="Return to Colloquia"
            sx={{
              border: 0,
              background: "transparent",
              padding: 0,
              cursor: "pointer",

              display: "flex",
              alignItems: "center"
            }}
          >
            <Box
              component="img"
              src="/Colloquia_Logo.png"
              alt="Colloquia"
              sx={{
                height: {
                  xs: 55,
                  md: 65
                },

                width: "auto",

                borderRadius: "12px"
              }}
            />
          </Box>

          <Button
            onClick={() => history.push("/")}
            sx={{
              color: CONTACT_GRAY,
              fontWeight: 300,
              textTransform: "none",
              fontSize: "0.9rem",

              "&:hover": {
                color: CONTACT_WHITE,
                bgcolor: "transparent"
              }
            }}
          >
            Return to Colloquia
          </Button>
        </Box>

        {/* =====================================================
            MAIN
            ===================================================== */}

        <Box
          component="main"
          sx={{
            width: "100%",
            maxWidth: 920,

            mx: "auto",

            px: {
              xs: 4,
              sm: 6,
              md: 8
            },

            pt: {
              xs: 8,
              md: 12
            },

            pb: {
              xs: 10,
              md: 14
            }
          }}
        >
          {/* =====================================================
              TITLE
              ===================================================== */}

          <Box
            sx={{
              mb: {
                xs: 7,
                md: 9
              }
            }}
          >
            <Typography
              component="h1"
              sx={{
                fontSize: {
                  xs: "2.5rem",
                  sm: "3.2rem",
                  md: "4rem"
                },

                lineHeight: 1.1,
                fontWeight: 300,
                letterSpacing: "-0.035em",

                color: CONTACT_WHITE,

                mb: 2
              }}
            >
              Contact
            </Typography>

            <Typography
              sx={{
                maxWidth: 700,

                fontSize: {
                  xs: "1rem",
                  md: "1.1rem"
                },

                lineHeight: 1.75,
                fontWeight: 300,

                color: CONTACT_GRAY
              }}
            >
              We'd like to hear from you. Whether you have a
              question, suggestion, partnership inquiry, or need
              assistance with Colloquia, you can reach us through
              the channels below.
            </Typography>
          </Box>

          {/* =====================================================
              CONTACT METHODS
              ===================================================== */}

          <Box
            sx={{
              display: "grid",

              gridTemplateColumns: {
                xs: "1fr",
                md: "1fr 1fr"
              },

              gap: 2,

              mb: 9
            }}
          >
            {/* EMAIL */}

            <Box
              sx={{
                ...contactCardSx,
                gridColumn: {
                  xs: "auto",
                  md: "1 / -1"
                }
              }}
            >
              <Typography
                sx={{
                  fontSize: "0.75rem",
                  letterSpacing: "0.16em",
                  textTransform: "uppercase",
                  color: CONTACT_MUTED,
                  fontWeight: 400,
                  mb: 1.5
                }}
              >
                Email
              </Typography>

              <Typography
                sx={{
                  fontSize: {
                    xs: "1.1rem",
                    md: "1.3rem"
                  },
                  fontWeight: 300,
                  color: CONTACT_WHITE,
                  wordBreak: "break-word"
                }}
              >
                {CONTACT_EMAIL}
              </Typography>

            </Box>

            {/* X */}

            {CONTACT_X && (
              <Box sx={contactCardSx}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    letterSpacing: "0.16em",
                    textTransform: "uppercase",
                    color: CONTACT_MUTED,
                    fontWeight: 400,
                    mb: 1.5
                  }}
                >
                  X / Twitter
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.15rem",
                    fontWeight: 300,
                    color: CONTACT_WHITE,
                    mb: 2
                  }}
                >
                  Follow Colloquia
                </Typography>

                <Button
                  component="a"
                  href={CONTACT_X}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  sx={{
                    color: CONTACT_WHITE,
                    borderColor: "#444",

                    textTransform: "none",
                    fontWeight: 300,

                    "&:hover": {
                      borderColor: "#777",
                      bgcolor: "#111"
                    }
                  }}
                >
                  Visit X
                </Button>
              </Box>
            )}

            {/* LINKEDIN */}

            {CONTACT_LINKEDIN && (
              <Box sx={contactCardSx}>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    letterSpacing: "0.16em",
                    textTransform: "uppercase",
                    color: CONTACT_MUTED,
                    fontWeight: 400,
                    mb: 1.5
                  }}
                >
                  LinkedIn
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.15rem",
                    fontWeight: 300,
                    color: CONTACT_WHITE,
                    mb: 2
                  }}
                >
                  Connect with Colloquia
                </Typography>

                <Button
                  component="a"
                  href={CONTACT_LINKEDIN}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  sx={{
                    color: CONTACT_WHITE,
                    borderColor: "#444",

                    textTransform: "none",
                    fontWeight: 300,

                    "&:hover": {
                      borderColor: "#777",
                      bgcolor: "#111"
                    }
                  }}
                >
                  Visit LinkedIn
                </Button>
              </Box>
            )}
          </Box>

          {/* =====================================================
              SUPPORT
              ===================================================== */}

          <Box sx={{ mb: 8 }}>
            <Typography sx={sectionTitleSx}>
              Need support?
            </Typography>

            <Typography sx={bodySx}>
              If you're experiencing a problem with your account
              or with the Colloquia platform, our Support page
              contains information about the most common types of
              issues and how to report them.
            </Typography>

            <Button
              variant="outlined"
              onClick={() => history.push("/support")}
              sx={{
                color: CONTACT_WHITE,
                borderColor: "#444",

                textTransform: "none",
                fontWeight: 300,

                "&:hover": {
                  borderColor: "#777",
                  bgcolor: "#111"
                }
              }}
            >
              Visit Support
            </Button>
          </Box>

          {/* =====================================================
              PARTNERSHIPS
              ===================================================== */}

          <Box sx={{ mb: 8 }}>
            <Typography sx={sectionTitleSx}>
              Partnerships & opportunities
            </Typography>

            <Typography sx={bodySx}>
              We're interested in hearing from people and
              organizations who believe in the mission of building
              a more intellectually substantive social environment.
            </Typography>

            <Typography sx={bodySx}>
              If you'd like to discuss a partnership, collaboration,
              investment opportunity, media inquiry, or other
              professional matter, please reach out by email.
            </Typography>
          </Box>

          {/* =====================================================
              COMPANY
              ===================================================== */}

          <Box sx={{ mb: 9 }}>
            <Typography sx={sectionTitleSx}>
              Colloquia
            </Typography>

            <Typography sx={bodySx}>
              Colloquia is a social media platform built around the
              idea that the quality of ideas—and the people
              developing them—should matter more.
            </Typography>

            <Typography
              sx={{
                fontSize: "0.95rem",
                lineHeight: 1.8,
                fontWeight: 300,
                color: CONTACT_GRAY
              }}
            >
              From Penneferies Squire Capital
            </Typography>
          </Box>

          {/* =====================================================
              FOOTER NAVIGATION
              ===================================================== */}

          <Box
            sx={{
              borderTop: "1px solid #222",

              pt: 4,

              display: "flex",
              flexWrap: "wrap",

              gap: {
                xs: 0.5,
                md: 1
              }
            }}
          >
            {[
              ["About", "/about"],
              ["Terms", "/terms"],
              ["Privacy", "/privacy"],
              ["Careers", "/careers"],
              ["Support", "/support"],
              ["Contact", "/contact"]
            ].map(([label, path]) => (
              <Button
                key={label}
                onClick={() => history.push(path)}
                sx={{
                  color:
                    label === "Contact"
                      ? CONTACT_WHITE
                      : CONTACT_MUTED,

                  textTransform: "none",
                  fontWeight: 300,
                  fontSize: "0.9rem",

                  minWidth: "auto",
                  px: 1,

                  "&:hover": {
                    color: CONTACT_WHITE,
                    bgcolor: "transparent"
                  }
                }}
              >
                {label}
              </Button>
            ))}
          </Box>

          <Typography
            sx={{
              mt: 3,
              color: "#555",
              fontSize: "0.8rem",
              fontWeight: 300
            }}
          >
            © 2026 Colloquia from Penneferies Squire Capital
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default ContactPage;